import React from 'react'
import { useOrderStore } from 'src/hooks/order';

const OrderDetailViewInvoicesPopup = (props) => {
  const { SetStatus, data } = props;
  const [{ }, { }, { order_download_single_invoice }] = useOrderStore();

  const downloadSingleInvoice = async (invoiceNumber) => {
    await order_download_single_invoice({ invoiceNumber: invoiceNumber })
  }

  return (
    <>
      <div className="avnet-modal modal-530">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">View All Invoices</h3>
          </div>
          {/* Modal body */}
          <div className="modal-body py-0">
            <div className="clearfix" />

            <div className='mb-3 text-center mt-4 mb-5'>
              <div><b className='text-black'>Here are all of your invoices for PO Number {data.poNumber}</b></div>
              <a href={void (0)} className='text-blue'>Download all files</a>
            </div>

            <div className='m-b-30'>
              <div className="bs5 row text-center">
                {
                  data.invoiceData && data.invoiceData.length > 0 &&
                  data.invoiceData.map((v, i) => (
                    <div className='col-md-6 mb-1'
                      onClick={() => downloadSingleInvoice(v)}><a href={void (0)}>
                        <i className='fa fa-download me-2 text-black'></i><span className='text-blue'>{v}</span></a></div>
                  ))
                }
              </div>

            </div>
          </div>
          {/* Modal footer */}
          <div className="modal-footer justify-content-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                close
              </button>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default OrderDetailViewInvoicesPopup